/** Pill selector for the rotating ad-film series. */
export default function FilmChips({ films, index, onSelect, testid, compact = false }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${compact ? "" : "gap-2"}`} data-testid={testid} onClick={(e) => e.stopPropagation()}>
      {films.map((f, i) => (
        <button
          key={f.id}
          type="button"
          onClick={() => onSelect(i)}
          aria-pressed={i === index}
          className={`font-mono-lbl uppercase tracking-wider rounded-full border transition-colors ${
            compact ? "text-[10px] px-2.5 py-1" : "text-[11px] px-3 py-1.5"
          } ${
            i === index
              ? "bg-[#00F0FF] text-[#061536] border-[#00F0FF] font-bold"
              : "bg-[#02050F]/70 text-white/75 border-white/20 hover:border-[#00F0FF]/70 hover:text-[#00F0FF]"
          }`}
          data-testid={`${testid}-${f.id}`}
        >
          {f.short}
        </button>
      ))}
    </div>
  );
}
